import {
    addRecentlyRejectedSuggestionsTelemetry,
    tryRemoveFirstCharacterFromSuggestion,
} from '../actions/smartComposePluginActions';
import Suggestion from '../store/schema/Suggestion';
import store from '../store/store';
import updateTelemetryForSuggestionOnSuggestionRejected from '../telemetryHelpers/updateTelemetryForSuggestionOnSuggestionRejected';
import updateTelemetryForSuggestionOnTypedMatchingCharacter from '../telemetryHelpers/updateTelemetryForSuggestionOnTypedMatchingCharacter';
import { trace } from 'owa-trace';
import { IEditor } from 'roosterjs-editor-types';
import { ISmartComposeSession } from '@qas/smartcompose-tslibrary/dist/src/session';
import { RejectionReason } from '@qas/smartcompose-tslibrary/dist/src/smartComposeInteraction';

const SUGGESTION_VISIBLE_THRESHOLD = 50; // The length of time (in ms) that a suggestion needs to be visible on screen before we can consider a rejection to have been seen

export default function checkIfTypedCharacterMatchesCurrentSuggestion(
    editor: IEditor,
    characterTyped: string,
    currentSmartComposeSession: ISmartComposeSession
): boolean {
    const currentlyShownSuggestion = store().viewState.currentlyShownSuggestion;
    if (currentlyShownSuggestion) {
        // in this case we are showing a suggestion
        if (
            currentlyShownSuggestion.suggestionText &&
            currentlyShownSuggestion.suggestionText.length > 0 &&
            currentlyShownSuggestion.suggestionText[0] === characterTyped
        ) {
            trace.info('[smartCompose] typed matching character');
            updateTelemetryForSuggestionOnTypedMatchingCharacter(
                currentlyShownSuggestion.suggestionTelemetry
            );

            tryRemoveFirstCharacterFromSuggestion(editor, currentSmartComposeSession);

            return true;
        } else {
            trace.info('[smartCompose] typed non-matching character');
            addRecentlyRejectedSuggestionsTelemetry(currentlyShownSuggestion.suggestionTelemetry);
            updateTelemetryForSuggestionOnSuggestionRejected(
                currentlyShownSuggestion.suggestionTelemetry,
                getRejectionReasonForSuggestion(currentlyShownSuggestion),
                characterTyped
            );
        }
    }

    return false;
}

function getRejectionReasonForSuggestion(suggestion: Suggestion): RejectionReason {
    const now = Date.now();
    const shownTime = suggestion.suggestionTelemetry.initialRenderTime
        ? suggestion.suggestionTelemetry.initialRenderTime.valueOf()
        : 0;

    if (now - shownTime < SUGGESTION_VISIBLE_THRESHOLD) {
        trace.info(
            '[smartCompose] Suggestion rejected by typing non-matching character, but it was visible for very little time'
        );
        return RejectionReason.NotSeen;
    } else {
        trace.info(
            '[smartCompose] Suggestion rejected by typing non-matching character, and it was visible long enough'
        );
        return RejectionReason.TypeNotMatchingCharacter;
    }
}
